import { ValueFormatterParams } from "ag-grid-community";
import { formatDateTime } from "../../../utils/format/formatDateTime";

export function dateFormatter(params: ValueFormatterParams): string {
  return formatDateTime(params?.value, "DD-MMM-YYYY");
}
